// Build the Settings form state from the live `site` doc. Used at mount AND by the
// re-sync effect so the initial value and the refresh path can't drift.
export function formFromSite(site) {
  return {
    name: site.name,
    tagline: site.tagline || "",
    description: site.description || "",
    voice: site.voice,
    status: site.status,
    ai_budget_daily_usd: site.ai_budget_daily_usd,
    article_cap: site.article_cap,
    retention_hot_days: site.retention_hot_days,
    retention_archive_days: site.retention_archive_days,
    max_source_age_hours: site.max_source_age_hours ?? 24,
    max_rewrite_age_hours: site.max_rewrite_age_hours ?? 36,
    purge_pending_after_hours: site.purge_pending_after_hours ?? 6,
    auto_archive_ready_after_hours: site.auto_archive_ready_after_hours ?? 24,
    adsense_publisher_id: site.adsense_publisher_id || "",
    adsense_slots: { ...(site.adsense_slots || {}) },
    ga4_measurement_id: site.ga4_measurement_id || "",
    twitter_handle: site.twitter_handle || "",
    publisher_name: site.publisher_name || "",
    publisher_logo_url: site.publisher_logo_url || "",
    auto_publish_enabled: !!site.auto_publish_enabled,
    auto_publish_min_quality_score: site.auto_publish_min_quality_score ?? 0.7,
    auto_publish_daily_cap: site.auto_publish_daily_cap ?? 10,
    auto_publish_require_image: !!site.auto_publish_require_image,
    image_policy: site.image_policy || "network",
    ingest_frequency: site.ingest_frequency || "standard",
    facebook_url: site.facebook_url || "",
    instagram_handle: site.instagram_handle || "",
    youtube_url: site.youtube_url || "",
    tiktok_handle: site.tiktok_handle || "",
    linkedin_url: site.linkedin_url || "",
    threads_handle: site.threads_handle || "",
    bluesky_public_handle: site.bluesky_public_handle || "",
    whatsapp_url: site.whatsapp_url || "",
    market_data_enabled: !!site.market_data_enabled,
    market_data_ticker: site.market_data_ticker !== false,
    market_data_sidebar: site.market_data_sidebar !== false,
    market_data_symbols: site.market_data_symbols || "",
    custom_head_html: site.custom_head_html || "",
    about_html: site.about_html || "",
    tracking_forward_url: site.tracking_forward_url || "",
    // static (lead-gen) sites
    form_embed_html: site.form_embed_html || "",
    business_address: site.business_address || "",
    support_email: site.support_email || "",
    static_palette: site.static_palette || "harbor",
    static_font: site.static_font || "sora",
  };
}
